import { IConfigStorage } from "../../../../Common/IConfigStorage";
import { DataUtilities } from "../../../../Common/DataUtilities";
import { IDesignValidationProvider, ValidationIssue } from "../../../../Common/IDesignValidationProvider";

export class RuleTableColumn implements IConfigStorage, IDesignValidationProvider {
    _id: string = DataUtilities.generateUniqueId();

    name?: string;

    path?: string;

    constructor(name?: string) {
        this.name = name;
        this.path = name;
    }

    getStorageData(): object {
        let data = {};

        Reflect.set(data, "_id", this._id);
        Reflect.set(data, "name", this.name);
        Reflect.set(data, "path", this.path);

        return data;
    }

    setStorageData(data: object): void {
        this._id = Reflect.get(data, "_id");
        this.name = Reflect.get(data, "name");
        this.path = Reflect.get(data, "path");
    }

    getDesignValidationIssues(): ValidationIssue[] {
        let issues: ValidationIssue[] = [];
        if (this.name === "") {
            issues.push(new ValidationIssue("Column name required"));
        }

        if (!this.path) {
            issues.push(new ValidationIssue("Column data path required"));
        }

        return issues;
    }
}
